import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import { Box, Typography } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from '@mui/icons-material/Email';
import logo from '~/assets/images/loGo.png';

const Footer = () => {
    return (
        <Box sx={{ backgroundColor: 'var(--blue)', color: '#FFFFFF', paddingInline: 2, paddingBlock: 4 }} >
            <Grid container spacing={2}
                sx={{ maxWidth: 'lg', marginInline: 'auto', borderBottom: '1px solid var(--gray-2)', paddingBottom: 4 }}>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                        LIÊN HỆ VỚI CHÚNG TÔI
                    </Typography>
                    <Typography variant='h3' sx={{ mt: 2, fontWeight: 'bold' }}>
                        (+84) 02773 881.715
                    </Typography>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                        THỜI GIAN LÀM VIỆC
                    </Typography>
                    <Typography sx={{ mt: 3 }}>
                        Bạn có thể liên hệ các ngày trong tuần, ngoại trừ ngày lễ và Chủ nhật sẽ có nhân viên hỗ trợ.
                    </Typography>
                    <Typography sx={{ mt: 2 }}>
                        Thứ hai đến Thứ bảy:  Buổi sáng: 7h30 - 11h30; Buổi chiều: 13h30 - 17h00
                    </Typography>

                </Grid>
            </Grid>
            <Grid container spacing={2}
                sx={{ maxWidth: 'lg', marginInline: 'auto', mt: 4, borderBottom: '1px solid var(--gray-2)', paddingBottom: 4 }}>
                <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                    <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                        ỨNG DỤNG CNTT CƠ BẢN
                    </Typography>
                    <Box sx={{ width: 150, mt: 3 }}>
                        <img className='img-cover' src={logo} alt="" />
                    </Box>
                </Grid>
                <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                    <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                        THI UDCNTT CƠ BẢN
                    </Typography>
                    <Link to="/exam-notice"
                        style={{
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            display: 'block',
                            marginTop: 16
                        }}
                        className='link-gray'
                        onClick={() => window.scrollTo({ top: 0 })}
                    >
                        Thông báo Thi
                    </Link>
                    <Link to="/exam-instruction"
                        style={{
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            display: 'block',
                            marginTop: 12
                        }}
                        className='link-gray'
                        onClick={() => window.scrollTo({ top: 0 })}
                    >
                        Hướng đẫn đăng ký thi
                    </Link>
                    <Link to="/exam-plan"
                        style={{
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            display: 'block',
                            marginTop: 12
                        }}
                        className='link-gray'
                        onClick={() => window.scrollTo({ top: 0 })}
                    >
                        Kế hoạch thi năm {new Date(Date.now()).getFullYear()}
                    </Link>
                    <Link to="https://nnth.dthu.edu.vn/tracuu_cccn.aspx"
                        target='_blank'
                        style={{
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            display: 'block',
                            marginTop: 12
                        }}
                        className='link-gray'
                    >
                        Tra cứu chứng chỉ
                    </Link>
                </Grid>
                <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                    <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                        ĐỊA CHỈ
                    </Typography>
                    <Typography sx={{ mt: 2, maxWidth: { lg: '75%', md: '75%', sm: "100%" } }}>
                        ki-ốt 1,2, số 783, Phạm Hữu Lầu, P6, Tp.Cao Lãnh, Đồng Tháp
                    </Typography>
                </Grid>
                <Grid size={{ lg: 3, md: 6, xs: 12 }}>
                    <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                        MẠNG XÃ HỘI
                    </Typography>
                    <Typography sx={{ mt: 2, display: 'flex' }}>
                        <EmailIcon sx={{ mr: 1 }} />ttnnth@dthu.edu.vn
                    </Typography>
                    <Link to="https://www.facebook.com/ttnnthdhdt"
                        style={{
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            display: 'flex',
                            marginTop: 12
                        }}
                        className='link-gray'
                    >
                        <FacebookIcon sx={{ mr: 1 }} /> Facebook
                    </Link>
                    <Link to="#"
                        style={{
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            display: 'flex',
                            marginTop: 12
                        }}
                        className='link-gray'
                    >
                        <YouTubeIcon sx={{ mr: 1 }} /> Youtube
                    </Link>
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ maxWidth: 'lg', marginInline: 'auto', mt: 4 }}>
                <Grid size={{ lg: 6, xs: 12 }}>
                    <Link to="/login"
                        style={{
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            display: 'block',
                            fontWeight: 'bold',
                        }}
                        className='link-gray'
                        onClick={() => window.scrollTo({ top: 0 })}
                    >
                        ĐĂNG NHẬP
                    </Link>
                </Grid>
                <Grid size={{ lg: 6, xs: 12 }}>
                    <Typography>
                        Copyright &copy; 2025 | Giao diện tùy chỉnh từ
                        <Link to="https://vstep.dthu.edu.vn/"
                            style={{
                                textDecoration: 'none',
                                color: '#FFFFFF',
                                display: 'inline-block',
                                marginLeft: 4
                            }}
                            className='link-gray'
                        >
                            VStep Dthu
                        </Link>
                    </Typography>
                </Grid>

            </Grid>
        </Box>
    );
}

export default Footer;